import { deepGet } from 'bam-deep-get';
import { appendScript } from '../utils/helpers';

const dssDataLayerDefaults = {
    campaignCode: '',
    cid: '',
    countryCode: '',
    countrycodeRegion: '',
    deviceLanguage: '',
    dssAccountId: '',
    dssDeviceId: '',
    dssSessionId: '',
    logInStatus: '',
    mid: '',
    pageName: '',
    pageURL: '',
    partnerId: '',
    redemptionCode: '',
    subscriberPurchased: '',
    swid: '',
    unid: '',
    userProductName: '',
    userProductSku: '',
    userSubscriptionState: '',
    userVisitorState: '',
    voucherCode: ''
};

export const AdobeLaunch = {
    /**
     * @description
     * @param {object} source Object containing key/value pairs to be searched
     * @param {array<string>} keys Array of keys to look for in the source object
     * @returns {object} a new object containing only keys found in source
     */
    pick: (source, keys) => {
        const dest = {};

        keys.forEach(k => {
            if (source.hasOwnProperty(k)) {
                dest[k] = source[k];
            }
        });

        return dest;
    },

    /**
     * Sets the dssDataLayer properties for the current page
     */
    updateDataLayer: () => {
        const { contextData } = window.AnalyticsManager;
        const { s } = window;

        window.dssDataLayer = AdobeLaunch.pick({
            ...dssDataLayerDefaults,
            ...contextData,
            logInStatus: contextData.loggedIn,
            pageName: (s && s.pageName) ? s.pageName : document.body.getAttribute('data-analytics-pagename'),
            pageURL: window.location.href,
            countryCode: window.dssMlpConfigs.regionConfig.regionCode,
            countrycodeRegion: window.dssMlpConfigs.regionConfig.group
        }, Object.keys(dssDataLayerDefaults));

        document.body.dispatchEvent(new CustomEvent('dynamicPageIsDisplayed', {
            bubbles: true,
            cancelable: true
        }));
    },

    /**
     * Dynamically appends the Adobe Launch script tag
     */
    loadScript: () => {
        const launchScriptUrl = deepGet(window, 'dssMlpConfigs.adobeLaunchUrl');

        if (launchScriptUrl) {
            appendScript(launchScriptUrl, () => {
                AdobeLaunch.updateDataLayer();
            });
        }
    }
};

/**
 * Initialized adobe launch. If the cmpDisabled is true append the script tag to load the JS file. If false the script
 * tag is loaded using OneTrust, so it just updates the dssDatalayer.
 * @param {Boolean} cmpDisabled Flag if the OneTrust CMP banner is being used or not.
 */
export function initAdobeLaunch(cmpDisabled) {
    if (cmpDisabled) {
        AdobeLaunch.loadScript();
    } else if (window.dssMlpConfigs.adobeLaunchUrl) {
        AdobeLaunch.updateDataLayer();
    }
}
